import { Input } from "../../../design/input";
import { Button } from "../../../design/button";
import { Heading, Subheading } from "../../../design/heading";
import { Text } from "../../../design/text";
import { Intake } from "../../../models/Intake";
import { useNavigate } from "react-router-dom";
import { useMatter } from "../../../contexts/MatterContext";

interface MatterCreatedViewProps {
  intake: Intake;
}

const MatterCreatedView: React.FC<MatterCreatedViewProps> = ({ intake }) => {
  const navigate = useNavigate();
  const { setCurrentMatterId } = useMatter();

  const onGetStartedPressed = () => {
    if (intake?.matterId) {
      setCurrentMatterId(intake.matterId);
      navigate("/events");
    }
  };
  return (
    <div>
      <Heading className="mb-4 text-xl font-semibold">
        Your Matter Has Been Created
      </Heading>

      <div className="mb-4">
        <Subheading className="text-lg font-medium">Matter Overview</Subheading>
        <Text>
          Here’s a summary of your matter based on the details you've provided.
          Review it carefully to ensure everything is accurate.
        </Text>
        <Text className="mt-2">
          {intake.summary || "No summary available."}
        </Text>
      </div>
      {intake.importantDetails && (
        <div className="mb-4">
          <Subheading className="text-lg font-medium">Key Findings</Subheading>
          <Text className="mb-2">
            Casey has highlighted some critical aspects of your matter. These
            details may be useful for legal strategy, documentation, or
            discussions with professionals.
          </Text>
          <Text>{intake.importantDetails}</Text>
        </div>
      )}
      <div className="mt-6">
        <Button
          onClick={onGetStartedPressed}
          className="px-4 py-2 text-white bg-blue-600 rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
        >
          Get Started
        </Button>
      </div>
    </div>
  );
};

export default MatterCreatedView;
